import { render, staticRenderFns } from "./AddTemplateConfirm.vue?vue&type=template&id=9892c5ce&"
import script from "./AddTemplateConfirm.vue?vue&type=script&lang=js&"
export * from "./AddTemplateConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddTemplateConfirm.vue"
export default component.exports